
export enum UnitSystem {
  Imperial = 'IMPERIAL',
  Metric = 'METRIC'
}
